// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "training_video".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { trainingCategoryValues } from '@borradh-workspace/labels';
/** Response atom for the "training_video" table (1:1 with a DB row, on the wire). */
export const trainingVideoAtomSchema = z.object({
    id: z.string(),
    title: z.string(),
    description: z.string().nullable(),
    cdnUrl: z.string(),
    thumbnailUrl: z.string().nullable(),
    durationSeconds: z.number().nullable(),
    category: z.enum(trainingCategoryValues),
    sortOrder: z.number(),
    isPublished: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=trainingVideo.js.map